import { computed } from 'vue';
import { useAccount } from './useAccount';

export function useCampaignSendsQuota() {
  const { currentAccount } = useAccount();

  const remainingSends = computed(() => {
    const dim = currentAccount.value?.limits?.campaign_sends;
    if (!dim || dim.allowed == null) return null;
    const remaining = dim.remaining ?? dim.allowed - (dim.consumed ?? 0);
    return Math.max(0, remaining);
  });

  const sendsExhausted = computed(() => {
    if (remainingSends.value == null) return false;
    return remainingSends.value <= 0;
  });

  return { remainingSends, sendsExhausted };
}
